import { BankSlipInformations } from "@aprosoja/containers";
import { useToastFeedbackUser } from "@aprosoja/stores";
import { Button } from "@aprosoja/ui";

import { useSignUpContext } from "@/app/screens/sign-up/context/sign-up.context";
import ContentWrapper from "../components/content-wrapper";

const BankSlipInfo = () => {
  const { setToast } = useToastFeedbackUser();
  const { signUpReducer, setSignUpReducer } = useSignUpContext();

  return (
    <div className="flex flex-col w-full gap-size-x6">
      <ContentWrapper title="" hasSummary>
        <BankSlipInformations
          code={signUpReducer?.pixOrBankSlipInfo?.paymentCode ?? ""}
          bankSlipLink={signUpReducer?.pixOrBankSlipInfo?.invoiceUrl ?? ""}
        />
      </ContentWrapper>
      <div className="flex w-full justify-end">
        <Button
          className="rounded-border-radius-small"
          onClick={() =>
            setSignUpReducer({ type: "signUpStep", signUpStepPayload: 5 })
          }
        >
          Prosseguir
        </Button>
      </div>
    </div>
  );
};

export default BankSlipInfo;
